export default {
  id: 'companies',
  title: 'Upravljanje firmama',
  icon: 'mdi-briefcase',
  show: true,
  order: 2,
  children: [
    {
      id: 'companies-overview',
      title: 'Pregled firmi',
      icon: 'mdi-eye',
      show: true,
      order: 1,
      content: () => `
      <h2 id="overview">Pregled firmi</h2>
      <p>
        U AI Kasa sustavu, firma (Company) predstavlja pravnu osobu koja koristi sustav.
        Svaka firma ima vlastite blagajne, artikle, cjenike, korisnike i postavke.
      </p>

      <div class="info-box">
        <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Napomena:</strong> Korisnik može imati pristup više firmi. Odabir aktivne firme se vrši u gornjem navigation baru.
        </div>
      </div>

      <h3 class="mt-4">Pristup pregledu firmi</h3>
      <ol>
        <li>U lijevom meniju kliknite na <strong>"Dashboard"</strong> ili <strong>"Postavke"</strong></li>
        <li>Ako imate više firmi, vidjet ćete listu u dropdown meniju</li>
        <li>Za administraciju firmi, idite na <strong>"Postavke" → "Firme"</strong></li>
      </ol>

      <h3 class="mt-4">Što se prikazuje na popisu firmi?</h3>
      <table class="info-table">
        <thead>
          <tr>
            <th>Polje</th>
            <th>Opis</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Naziv</strong></td>
            <td>Službeni naziv firme</td>
          </tr>
          <tr>
            <td><strong>OIB</strong></td>
            <td>Osobni identifikacijski broj firme</td>
          </tr>
          <tr>
            <td><strong>Adresa</strong></td>
            <td>Sjedište firme</td>
          </tr>
          <tr>
            <td><strong>Status</strong></td>
            <td>Aktivan / Neaktivan</td>
          </tr>
          <tr>
            <td><strong>Prodajna mjesta</strong></td>
            <td>Broj prodajnih mjesta</td>
          </tr>
          <tr>
            <td><strong>Blagajne</strong></td>
            <td>Broj blagajna</td>
          </tr>
        </tbody>
      </table>

      <h3 class="mt-4">Odabir aktivne firme</h3>
      <p>Ako imate pristup više firmi:</p>
      <ol>
        <li>U gornjem desnom kutu, kliknite na <strong>dropdown sa nazivom firme</strong></li>
        <li>Odaberite firmu iz liste</li>
        <li>Aplikacija će se osvježiti i prikazati podatke odabrane firme</li>
      </ol>

      <div class="warning-box">
        <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Važno:</strong> Sve akcije (izdavanje računa, kreiranje artikala, izvještaji) se izvršavaju za trenutno odabranu firmu!
        </div>
      </div>

      <h3 class="mt-4">Pretraga i filtriranje</h3>
      <p>Na stranici sa popisom firmi možete:</p>
      <ul>
        <li><strong>Pretraživati</strong> - Po nazivu, OIB-u ili adresi</li>
        <li><strong>Filtrirati</strong> - Po statusu (aktivno/neaktivno)</li>
        <li><strong>Sortirati</strong> - Po bilo kojem stupcu u tablici</li>
      </ul>

      <h3 class="mt-4">Akcije nad firmom</h3>
      <p>Za svaku firmu dostupne su sljedeće akcije:</p>
      <ul>
        <li><i class="mdi mdi-eye"></i> <strong>Pregledaj</strong> - Detaljan prikaz firme</li>
        <li><i class="mdi mdi-pencil"></i> <strong>Uredi</strong> - Uređivanje osnovnih podataka</li>
        <li><i class="mdi mdi-cog"></i> <strong>Postavke</strong> - Konfiguracija (certifikati, fiskalizacija, itd.)</li>
        <li><i class="mdi mdi-account-multiple"></i> <strong>Korisnici</strong> - Upravljanje korisnicima firme</li>
      </ul>

      <div class="success-box">
        <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Savjet:</strong> Uvijek provjerite koja je firma trenutno aktivna prije nego kreirate račune ili artikle!
        </div>
      </div>

      <h2 id="tips" class="mt-6">Česta pitanja</h2>
      <ul>
        <li><strong>Mogu li imati više firmi?</strong> - Da, jedan korisnik može imati pristup više firmi</li>
        <li><strong>Mogu li prebacivati artikle između firmi?</strong> - Ne, svaka firma ima vlastite artikle</li>
        <li><strong>Koliko košta dodatna firma?</strong> - Kontaktirajte podršku za cjenik</li>
      </ul>
    `
    },
    {
      id: 'add-company',
      title: 'Dodavanje firme',
      icon: 'mdi-plus',
      show: true,
      order: 2,
      content: () => `
      <h2 id="add-company">Dodavanje nove firme</h2>
      <p>
        Kreiranje nove firme u AI Kasa sustavu omogućava vam da započnete
        s novim poslovnim subjektom ili odvojite poslovanje različitih entiteta.
      </p>

      <div class="info-box">
        <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Napomena:</strong> Za dodavanje nove firme potrebne su vam privilegije administratora.
        </div>
      </div>

      <h3 class="mt-4">Korak po korak</h3>

      <h4 class="mt-3">1. Otvaranje forme</h4>
      <ol>
        <li>Idite na <strong>"Postavke" → "Firme"</strong></li>
        <li>Kliknite na gumb <strong>"+ Dodaj novu firmu"</strong></li>
        <li>Otvara se forma za kreiranje nove firme</li>
      </ol>

      <h4 class="mt-3">2. Osnovni podaci</h4>
      <table class="info-table">
        <thead>
          <tr>
            <th>Polje</th>
            <th>Obavezno</th>
            <th>Opis</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Naziv firme *</strong></td>
            <td>Da</td>
            <td>Službeni naziv (npr. "Moja trgovina d.o.o.")</td>
          </tr>
          <tr>
            <td><strong>OIB *</strong></td>
            <td>Da</td>
            <td>11-znamenkasti OIB firme</td>
          </tr>
          <tr>
            <td><strong>Kratki naziv</strong></td>
            <td>Ne</td>
            <td>Skraćeni naziv za lakše prepoznavanje</td>
          </tr>
          <tr>
            <td><strong>Email</strong></td>
            <td>Ne</td>
            <td>Kontakt email firme</td>
          </tr>
          <tr>
            <td><strong>Telefon</strong></td>
            <td>Ne</td>
            <td>Kontakt telefon</td>
          </tr>
          <tr>
            <td><strong>Web stranica</strong></td>
            <td>Ne</td>
            <td>URL web stranice</td>
          </tr>
        </tbody>
      </table>

      <h4 class="mt-3">3. Adresa sjedišta</h4>
      <ul>
        <li><strong>Ulica i broj *</strong> - Adresa sjedišta firme</li>
        <li><strong>Poštanski broj *</strong> - 5-znamenkasti poštanski broj</li>
        <li><strong>Grad *</strong> - Naziv grada</li>
        <li><strong>Država *</strong> - Odaberite iz dropdown liste (default: Hrvatska)</li>
      </ul>

      <div class="warning-box">
        <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Važno:</strong> OIB mora biti validan. Sustav automatski provjerava ispravnost OIB-a.
        </div>
      </div>

      <h4 class="mt-3">4. Logo firme (opcionalno)</h4>
      <ol>
        <li>Kliknite na <strong>"Upload logo"</strong></li>
        <li>Odaberite sliku (PNG, JPG, SVG)</li>
        <li>Preporučena veličina: 500x500px, kvadratni omjer</li>
        <li>Logo će se prikazivati na računima</li>
      </ol>

      <h4 class="mt-3">5. Certifikat za fiskalizaciju</h4>
      <p>Za fiskalizaciju računasada AI Kasa potreban je FINA certifikat:</p>
      <ol>
        <li>U sekciji <strong>"Fiskalizacija"</strong> kliknite <strong>"Upload certifikat"</strong></li>
        <li>Odaberite .pfx ili .p12 datoteku</li>
        <li>Unesite <strong>lozinku certifikata</strong></li>
        <li>Sustav automatski provjerava valjanost certifikata</li>
      </ol>

      <div class="info-box">
        <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Napomena:</strong> Certifikat možete dodati i kasnije u postavkama firme.
        </div>
      </div>

      <h4 class="mt-3">6. PDV postavke</h4>
      <p>Odaberite je li firma u sustavu PDV-a:</p>
      <ul>
        <li><input type="checkbox" checked> <strong>U sustavu PDV-a</strong> - Ako je firma u sustavu PDV-a</li>
        <li><input type="checkbox"> <strong>Nije u sustavu PDV-a</strong> - Za obrte i male tvrtke izvan sustava</li>
      </ul>

      <h4 class="mt-3">7. Valuta</h4>
      <ul>
        <li>Odaberite primarnu valutu (EUR, HRK, USD, itd.)</li>
        <li>Default: EUR (€)</li>
        <li>Možete dodati dodatne valute kasnije</li>
      </ul>

      <h4 class="mt-3">8. Spremanje firme</h4>
      <ol>
        <li>Provjerite jesu li sva obavezna polja popunjena</li>
        <li>Kliknite <strong>"Spremi"</strong></li>
        <li>Sustav kreira firmu i automatski vas prebacuje na popis firmi</li>
        <li>Nova firma je sada dostupna u dropdown meniju</li>
      </ol>

      <div class="success-box">
        <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Savjet:</strong> Nakon kreiranja firme, idite na "Postavke" → "Prodajna mjesta" da dodate prvo prodajno mjesto i blagajnu.
        </div>
      </div>

      <h3 class="mt-4">Što slijedi nakon kreiranja firme?</h3>
      <p>Nakon što ste kreirali firmu, potrebno je postaviti:</p>
      <ol>
        <li><strong>Prodajno mjesto</strong> - Fizička lokacija (trgovina, restoran)</li>
        <li><strong>Blagajne</strong> - Dodati blagajne za izdavanje računa</li>
        <li><strong>Artikle</strong> - Unijeti proizvode/usluge</li>
        <li><strong>Cjenik</strong> - Postaviti cijene za prodajno mjesto</li>
        <li><strong>Korisnike</strong> - Dodati zaposlenike koji će koristiti sustav</li>
      </ol>

      <h3 class="mt-4">Uređivanje firme</h3>
      <p>Ako trebate izmijeniti podatke firme:</p>
      <ol>
        <li>Idite na <strong>"Postavke" → "Firme"</strong></li>
        <li>Pronađite firmu u listi</li>
        <li>Kliknite <i class="mdi mdi-pencil"></i> <strong>"Uredi"</strong></li>
        <li>Izmjenite potrebne podatke</li>
        <li>Kliknite <strong>"Spremi"</strong></li>
      </ol>

      <div class="warning-box">
        <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Napomena:</strong> OIB firme se NE MOŽE mijenjati nakon kreiranja!
        </div>
      </div>

      <h2 id="tips" class="mt-6">Česta pitanja</h2>
      <ul>
        <li><strong>Mogu li obrisati firmu?</strong> - Ne, firma se može samo deaktivirati</li>
        <li><strong>Koliko firma mogu imati?</strong> - Nema tehničkog ograničenja, ali postoji komercijalno ograničenje ovisno o pretplati</li>
        <li><strong>Što ako nemam certifikat?</strong> - Možete kreirati firmu i dodati certifikat kasnije, ali nećete moći fiskalizirati račune</li>
        <li><strong>Može li firma imati više certifikata?</strong> - Da, za različita prodajna mjesta</li>
      </ul>
    `
    },
    {
      id: 'company-settings',
      title: 'Postavke firme',
      icon: 'mdi-cog',
      show: true,
      order: 3,
      content: () => `
      <h2 id="company-settings">Postavke firme</h2>
      <p>
        Postavke firme omogućavaju konfiguraciju osnovnih podataka,
        certifikata za fiskalizaciju i drugih ključnih parametara.
      </p>

      <h3 class="mt-4">Pristup postavkama</h3>
      <ol>
        <li>Idite na <strong>"Postavke" → "Firma" → "Postavke"</strong></li>
        <li>Ili u gornjem baru odaberite firmu i kliknite <i class="mdi mdi-cog"></i></li>
      </ol>

      <h3 class="mt-4">Osnovni podaci</h3>
      <p>Uređivanje osnovnih informacija firme:</p>
      <ul>
        <li><strong>Naziv</strong> - Službeni naziv firme</li>
        <li><strong>OIB</strong> - NE MOŽE se mijenjati nakon kreiranja!</li>
        <li><strong>Adresa</strong> - Sjedište firme</li>
        <li><strong>Kontakt podaci</strong> - Email, telefon, web stranica</li>
        <li><strong>Logo</strong> - Upload ili promjena logoa</li>
      </ul>

      <h3 class="mt-4">Certifikati za fiskalizaciju</h3>
      <p>Upravljanje FINA certifikatima:</p>
      <ol>
        <li>U sekciji <strong>"Certifikati"</strong> kliknite <strong>"Dodaj certifikat"</strong></li>
        <li>Upload .pfx ili .p12 datoteke</li>
        <li>Unesite lozinku certifikata</li>
        <li>Sustav automatski validira certifikat</li>
        <li>Postavite kao <strong>"Aktivni certifikat"</strong></li>
      </ol>

      <div class="warning-box">
        <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Istjecanje certifikata:</strong> Sustav vas automatski upozorava 30 dana prije isteka certifikata. Nabavite novi na vrijeme!
        </div>
      </div>

      <h3 class="mt-4">PDV postavke</h3>
      <ul>
        <li><strong>U sustavu PDV-a</strong> - Da/Ne</li>
        <li><strong>PDV ID</strong> - HR + OIB (automatski)</li>
        <li><strong>Zadane PDV stope</strong> - 25%, 13%, 5%, 0%</li>
      </ul>

      <h3 class="mt-4">Valute</h3>
      <p>Upravljanje valutama (vidi "Različite cijene po valuti"):</p>
      <ul>
        <li>Dodavanje novih valuta</li>
        <li>Postavljanje tečajeva</li>
        <li>Odabir primarne valute</li>
      </ul>

      <h3 class="mt-4">Fiskalizacija - Testni način</h3>
      <p>Za testiranje prije produkcije:</p>
      <ul>
        <li>Uključite <strong>"Testni način"</strong></li>
        <li>Sve račune šalje na FINA testni server</li>
        <li>Ne utječe na pravu evidenciju</li>
        <li>Isključite prije normalnog rada!</li>
      </ul>

      <div class="success-box">
        <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Savjet:</strong> Prije puštanja u produkciju, testirajte fiskalizaciju u testnom načinu s nekoliko probnih računa.
        </div>
      </div>
    `
    }
  ]
}
